import { render } from "./mainSlider.vue?vue&type=template&id=5a23aa91"
import script from "./mainSlider.vue?vue&type=script&lang=js"
export * from "./mainSlider.vue?vue&type=script&lang=js"

import "./mainSlider.vue?vue&type=style&index=0&id=5a23aa91&lang=css"

import exportComponent from "E:\\Websites\\Green Earth Marine Project\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__